(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    var EXCLUDED_TYPES = {
      header: true,
      footer: true,
      hero: true,
      'hero-carousel': true,
      'fast-quote-bar': true,
      'promo-modal': true,
      'scrolling-keywords': true,
      'mission-marquee': true
    };

    var observer = null;

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function sectionType(section) {
      return (
        section.getAttribute('data-shopify-section-type') ||
        (section.id && section.id.replace(/^shopify-section-/, '')) ||
        ''
      );
    }

    function isEligible(section) {
      if (!section || !section.classList || !section.classList.contains('shopify-section')) {
        return false;
      }
      if (section.closest('.site-header-anchor')) return false;
      if (section.querySelector('[data-site-footer-boundary]')) return false;
      if (section.querySelector('.fast-quote-bar, .promo-modal')) return false;
      var type = sectionType(section);
      if (type.indexOf('fast-quote-bar') !== -1) return false;
      return type === '' || !EXCLUDED_TYPES[type];
    }

    function revealSection(section) {
      section.classList.add('scroll-reveal--visible');
      if (observer) observer.unobserve(section);
    }

    function isSectionInView(section) {
      var rect = section.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      return rect.top < viewportHeight * 0.92 && rect.bottom > viewportHeight * 0.08;
    }

    function bindSection(section) {
      if (!isEligible(section) || section.classList.contains('scroll-reveal')) return;

      if (prefersReducedMotion()) {
        section.classList.add('scroll-reveal', 'scroll-reveal--visible');
        return;
      }

      var alreadyVisible = isSectionInView(section);

      requestAnimationFrame(function () {
        section.classList.add('scroll-reveal');
        if (alreadyVisible) {
          revealSection(section);
          return;
        }

        if (!observer) {
          observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                revealSection(entry.target);
              });
            },
            {
              root: null,
              rootMargin: '0px 0px -8% 0px',
              threshold: 0.12
            }
          );
        }

        observer.observe(section);
      });
    }

    function scan(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var nodes = scope.querySelectorAll
        ? scope.querySelectorAll('.shopify-section')
        : [];
      nodes.forEach(bindSection);
    }

    function boot() {
      if (prefersReducedMotion()) {
        document.querySelectorAll('.shopify-section').forEach(function (section) {
          if (!isEligible(section)) return;
          section.classList.add('scroll-reveal', 'scroll-reveal--visible');
        });
        return;
      }

      scan(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target) scan(event.target);
    });

    window
      .matchMedia('(prefers-reduced-motion: reduce)')
      .addEventListener('change', function () {
        if (observer) {
          observer.disconnect();
          observer = null;
        }
        document.querySelectorAll('.shopify-section.scroll-reveal').forEach(function (section) {
          section.classList.remove('scroll-reveal', 'scroll-reveal--visible');
        });
        boot();
      });
  })();
  } catch(e) { console.error(e); }
})();

})();
